import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle, Collapse
} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE, deleteErrorMsg,
    deleteMsg,
    error,
    LIST,
    NO, NO_DATA_FOUND,
    warning,
    YES
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {
    ButtonTableDelete,
    ButtonTableEdit, ButtonTableFilter
} from "../../../components/buttons/buttonsActions";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {showToastCustom} from "../../../components/toast/customToast";
import {showLoader} from "../../../components/loader/loader";
import {utilHelper} from "../../../jwt/_helpers";
import {roomService} from "../../../jwt/_services/hotel/roomService";
import RoomFilters from "./_filters";

export default function RoomList(props) {

    //Bootstraptable
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);
    const [loading, setLoading] = useState(false);

    // Items
    const [listItems, setListItems] = useState([]);

    // Filter props
    const [collapsed, setCollapsed] = useState(true);
    const [dataFilter, setDataFilter] = useState({
        number      : null,
        level       : null,
    });

    useEffect(() => {
        refreshDataList(page, currentIndex, sizePerPage, dataFilter);
    }, []);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage, dataFilter);
    };

    const refreshDataList = (page, currentIndex, sizePerPage, _dataFilter) => {
        setLoading(true);
        roomService.search(currentIndex, sizePerPage, _dataFilter)
            .then(result => {
                if (result){
                    setListItems(result.data);
                    setTotalSize(result.filtered);
                    setCurrentIndex(currentIndex);
                    setPage(page);
                    setSizePerPage(sizePerPage);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(0);
                    setPage(1);
                    setSizePerPage(10);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(0);
                setPage(1);
                setSizePerPage(10);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        roomService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);
                refreshDataList(page, currentIndex, sizePerPage, dataFilter);
                if (utilHelper.hasAssociateRecords()) {
                    showToastCustom(error, deleteErrorMsg, true);
                    utilHelper.restartAssociateRecords();
                } else {
                    showToastCustom(warning, deleteMsg, true);
                }
            });
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.setForm(true, itemToEdit, "FORM");
    }

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDataList(page, currentIndex, sizePerPage, _dataFilter);
    }

    const showFilters = () => {
        setCollapsed(!collapsed);
    }

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
                <ButtonTableEdit onClick={() => editItem(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid',
        headerStyle: {width: '150px'},
    }, {
        dataField: 'placeCode',
        text: 'Lugar / Edificio',
        sort: true,
    }, {
        dataField: 'level',
        text: 'Nivel',
        sort: true,
        headerStyle: {width: '80px'},
    }, {
        dataField: 'number',
        text: 'Numero',
        sort: true,
        headerStyle: {width: '80px'},
    }, {
        dataField: 'isSpecial',
        text: "Es especial",
        sort: true,
        headerStyle: {width: '100px'},
        formatter: activeFormatter
    }, {
        dataField: 'status',
        text: "Activo",
        sort: true,
        headerStyle: {width: '80px'},
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '150px'},
        formatter: actionsFormatter
    }];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>
                    {LIST}
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}  >
                    <RoomFilters refreshFiltered={refreshFiltered} />
                </Collapse>
                <CardBody className="">
                    {loading && showLoader()}
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listItems}
                        columns={columns}
                        noDataIndication={NO_DATA_FOUND}
                        pagination={paginationFactory({page, sizePerPage, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
}